'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

require('./../../levels/common.blocks/popup2/popup2.react.js');

require('./../../levels/common.blocks/popup2/_autoclosable/popup2_autoclosable_yes.react.js');

require('./../../levels/common.blocks/popup2/_hiding/popup2_hiding_yes.react.js');

require('./../../levels/common.blocks/popup2/_motionless/popup2_motionless_yes.react.js');

require('./../../levels/common.blocks/popup2/_target/popup2_target_anchor.react.js');

require('./../../levels/common.blocks/popup2/_target/popup2_target_position.react.js');

var _popup2_theme_normalReact = require('./../../levels/common.blocks/popup2/_theme/popup2_theme_normal.react.js');

var _popup2_theme_normalReact2 = _interopRequireDefault(_popup2_theme_normalReact);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var Popup = _popup2_theme_normalReact2.default.applyDecls(); // eslint-disable-line

exports.default = Popup;